import React, { Component } from 'react'
import { MuiTypography, muiWithStyles, MuiGrid, MuiButton, MuiDialog, MuiDialogActions, MuiDialogTitle, MuiDialogContent, MuiDialogContentText, MuiTextField } from '../../ui/MaterialUIComponents'
import theme from '../../../assests/theme'
// import Button from '@material-ui/core/Button';
// import Dialog from '@material-ui/core/Dialog';
// import DialogActions from '@material-ui/core/DialogActions';
// import DialogContent from '@material-ui/core/DialogContent';
// import DialogContentText from '@material-ui/core/DialogContentText';
// import DialogTitle from '@material-ui/core/DialogTitle';

export default class SubscriptionDialogComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            numberOfSections: 0
        }
    }
    handleChange = (event) => {
        let numberOfSections = event.target.value;
        this.setState({ numberOfSections: numberOfSections })
    }
    getMin = () => {
        
        if (this.props.action === "buyLicense") {
            if (this.props.licenseeSchool.school_master && this.props.licenseeSchool.school_master.totalNumberOfGroups < Number(this.props.i18n.license.minimumNumberOfGroup)) {
                return Number(this.props.i18n.license.minimumNumberOfGroup);
            } else {
                return this.props.licenseeSchool.school_master.totalNumberOfGroups;
            }
        } else if (this.props.action === "buyMoreSections") {
            return 1
        } else {
            console.log("unknown action", this.props.action)
        }
    }
    getActionDescription = () => {

        if (this.props.action === "buyLicense") {
            return this.props.i18n.license.buyLicenseDialogDiscription;
        } else if (this.props.action === "buyMoreSections") {
            return this.props.i18n.license.buyMoreSectionsDialogDiscription;
        }
    }
    getActionButtonText = () => {

        if (this.props.action === "buyLicense") {
            return this.props.i18n.license.buyLicenseDialogSubscribeButton;
        } else if (this.props.action === "buyMoreSections") {
            return this.props.i18n.license.buyMoreSectionsDialogSubscribeButton;
        }
    }
    getTimetableCount = (numberOfGroups) => {
        if (this.props.action === "buyLicense") {
            return numberOfGroups * 3;
        } else if (this.props.action === "buyMoreSections") {
            return Number(this.props.licenseeSchool.license.timeTableQuantity) + (numberOfGroups * 3)
        }
    }
    showNumberOfTimetableGeneration = () => {
        if (this.props.action === "buyLicense") {
            if (this.state !== null && this.state.numberOfSections >= this.props.i18n.license.minimumNumberOfGroup) {
                return true
            } else {
                return false
            }
        } else if (this.props.action === "buyMoreSections" && this.state.numberOfSections > 0) {
            return true
        }
    }
    render() {
        return (
            <div>
                <MuiDialog open={this.props.openDialog} onClose={this.props.handleClose} aria-labelledby="form-dialog-title" maxWidth='xs'>

                    <MuiDialogTitle style={{ background: theme.palette.grey.dark }} >
                        <MuiGrid container>
                            <MuiGrid item xs container alignItems="center" justify="center" >
                                <MuiTypography style={{ fontFamily: "Arial", fontSize: '15px', color: "white" }}>
                                    {/* Buy License */}
                                    {this.props.i18n.license.buyMoreSectionsDialogTitle}
                                </MuiTypography>
                            </MuiGrid>
                        </MuiGrid>
                    </MuiDialogTitle>
                    <MuiDialogContent>
                        <MuiGrid container xs={12} alignContent="center" justify="center">
                            <MuiTypography style={theme.typography.body2}>
                                <span dangerouslySetInnerHTML={{ __html: this.getActionDescription() }}></span>
                            </MuiTypography></MuiGrid>
                        {/* <MuiGrid container xs={12} >

                            <MuiTypography variant='caption' color='textSecondary' align='left'>
                                {this.props.i18n.license.minimumIs}&nbsp;{this.props.i18n.license.minimumNumberOfGroup}&nbsp;
                                {this.props.i18n.license.groups.toLowerCase()}
                            </MuiTypography>
                        </MuiGrid> */}
                        <MuiGrid container xs={12} alignContent="center" justify="center">
                            <MuiTextField
                                autoFocus
                                margin="dense"
                                label={this.props.i18n.license.numberOfGroups}
                                type="number"
                                fullWidth
                                onChange={(event) => this.handleChange(event)}
                                inputProps={{ min: this.getMin() }}
                                helperText={this.props.helpMessage}
                                error={this.props.showHelpMessage}
                            /></MuiGrid>
                        {this.showNumberOfTimetableGeneration() && < MuiGrid container xs={12} >

                            <MuiTypography variant='caption' color='textSecondary' align='left'>
                                {this.props.i18n.license.numberOfTimetableGeneration}  {this.getTimetableCount(this.state.numberOfSections)}
                            </MuiTypography>
                        </MuiGrid>
                        }
                    </MuiDialogContent>
                    <MuiDialogActions>
                        <MuiButton onClick={this.props.handleCloseDialog} style={theme.secondaryButtonStyle}>
                            {this.props.i18n.license.buyMoreSectionsDialogCancelButton}
                            {/* Cancel */}
                        </MuiButton>
                        <MuiButton onClick={(event) => this.props.subscribe(event, this.props.action, this.props.licenseeSchool, this.state.numberOfSections)}
                            style={this.state == null ? theme.primaryButtonDisabledStyle : theme.primaryButtonStyle}
                            disabled={this.state == null}
                        >

                            {this.getActionButtonText()}
                            {/* Subscribe */}
                        </MuiButton>
                    </MuiDialogActions>
                </MuiDialog>
            </div >
        );
    }
}